import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Card, Stat, Empty, usd } from "./ui";

const CATS = [["lessons", "Lessons"], ["images", "Images"], ["videos", "Videos"], ["voice", "Voice"], ["chat", "Chat"], ["agent", "Agent"]];

function TotalsBlock({ title, t, testid }) {
  return (
    <div data-testid={testid}>
      <div className="label-mono mb-2">{title}</div>
      <div className="grid grid-cols-2 gap-2">
        <Stat label="Credits used" value={t.all.credits} sub={`${t.all.count} actions`} testid={`${testid}-credits`} />
        <Stat label="Cost to us" value={usd(t.all.cost_usd)} sub="estimated" testid={`${testid}-cost`} />
      </div>
      <div className="grid grid-cols-3 gap-2 mt-2">
        {CATS.map(([k, n]) => (
          <Card key={k} className="!p-3" data-testid={`${testid}-${k}`}>
            <div className="text-[11px] text-slate-400">{n}</div>
            <div className="text-sm mt-0.5">{t.by_category[k].count} · {t.by_category[k].credits} cr</div>
            <div className="text-[11px] text-slate-500">{usd(t.by_category[k].cost_usd)}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}

const Breakdown = ({ bc }) => (
  <div className="text-[11px] text-slate-400 mt-1 flex flex-wrap gap-x-3">
    {CATS.filter(([k]) => bc[k].count).map(([k, n]) => <span key={k}>{n} {bc[k].count}</span>)}
  </div>
);

export function UsageSection() {
  const [days, setDays] = useState(7);
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get("/admin/usage", { params: { days } }).then(({ data }) => setData(data)).catch(() => toast.error("Couldn't load usage."));
  }, [days]);
  if (!data) return <Empty>Loading…</Empty>;
  return (
    <div className="space-y-5" data-testid="admin-usage-section">
      <TotalsBlock title="Last 7 days" t={data.totals["7d"]} testid="usage-7d" />
      <TotalsBlock title="Last 30 days" t={data.totals["30d"]} testid="usage-30d" />
      <div className="flex items-center gap-2">
        <span className="label-mono">Breakdown for</span>
        {[7, 30].map((d) => (
          <button key={d} data-testid={`usage-days-${d}`} onClick={() => setDays(d)} className={`rounded-full px-3 py-1 text-xs ${days === d ? "bg-mono-400/20 text-mono-200" : "text-slate-400 border border-white/10"}`}>{d} days</button>
        ))}
      </div>
      <div>
        <div className="label-mono mb-2">Per day</div>
        <div className="space-y-2" data-testid="usage-by-day">
          {data.by_day.length === 0 ? <Empty>No usage in this period.</Empty> : data.by_day.map((d) => (
            <Card key={d.date} className="!p-3">
              <div className="flex justify-between text-sm"><span>{d.date}</span><span>{d.all.credits} cr · {usd(d.all.cost_usd)}</span></div>
              <Breakdown bc={d.by_category} />
            </Card>
          ))}
        </div>
      </div>
      <div>
        <div className="label-mono mb-2">Per user</div>
        <div className="space-y-2" data-testid="usage-by-user">
          {data.by_user.length === 0 ? <Empty>No usage in this period.</Empty> : data.by_user.map((u) => (
            <Card key={u.user_id} className="!p-3">
              <div className="flex justify-between gap-3 text-sm"><span className="truncate">{u.email}</span><span className="shrink-0">{u.credits} cr · {usd(u.cost_usd)}</span></div>
              <Breakdown bc={u.by_category} />
            </Card>
          ))}
        </div>
      </div>
      <div className="text-[11px] text-slate-500">Cost to us is estimated per action from the provider costs set in Prices &amp; limits. Free daily images count as cost but 0 credits.</div>
    </div>
  );
}
